import SubHeaders from '@/components/Headers/SubHeaders'
import useTabs from '@/hooks/useTabs'
import FileIcons from '@/icons/FileIcons'
import InvoiceIcons from '@/icons/InvoiceIcons'
import OperatingCapabilityIcons from '@/icons/OperatingCapabilityIcons'
import PackageIcons from '@/icons/PackageIcons'
import ReceiptIcons from '@/icons/ReceiptIcons'
import { paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'vnetwork-ui'
import OperationExpenses from '../OperationExpenses'
import OtherFinancials from '../OtherFinancials'
import ServiceCosts from '../ServiceCosts'
import Allocations from './components/Allocations'
import ProductGroups from './components/ProductGroups'

const ServiceAnalytics = () => {
    const { t } = useTranslation()

    const { TabProps, TabComponent } = useTabs({
        tabs: [
            {
                label: t('invoices'),
                value: '',
                startIcon: <InvoiceIcons />,
                component: <Allocations />,
            },
            {
                label: t('product_groups'),
                value: 'product-groups',
                startIcon: <PackageIcons />,
                component: <ProductGroups />,
            },
            {
                label: t('costs'),
                value: 'costs',
                startIcon: <OperatingCapabilityIcons />,
                component: <ServiceCosts />,
            },
            {
                label: t('other_financials'),
                value: 'other-financials',
                startIcon: <ReceiptIcons />,
                component: <OtherFinancials />,
            },
            {
                label: t('operation_expenses'),
                value: 'operation-expenses',
                startIcon: <FileIcons />,
                component: <OperationExpenses />,
            },
        ],
    })

    return (
        <>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths?.reportRevenue,
                        title: t('report-revenue'),
                    },
                ]}
            />
            <div className="space-y-2">
                <Tabs {...TabProps} />
                {TabComponent}
            </div>
        </>
    )
}

export default ServiceAnalytics
